var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotPattern2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 269,
    height: 404,
    viewBox: "0 0 269 404",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_3915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H4V4H0V0Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0H24V4H20V0Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 0H44V4H40V0Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 0H64V4H60V0Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 0H84V4H80V0Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 0H104V4H100V0Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 0H124V4H120V0Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 0H144V4H140V0Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 0H164V4H160V0Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 0H184V4H180V0Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 0H204V4H200V0Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 0H224V4H220V0Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 0H244V4H240V0Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 0H264V4H260V0Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 0H284V4H280V0Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 0H304V4H300V0Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 0H324V4H320V0Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 0H344V4H340V0Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 0H364V4H360V0Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 0H384V4H380V0Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 0H404V4H400V0Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 20H4V24H0V20Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20H24V24H20V20Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 20H44V24H40V20Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 20H64V24H60V20Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 20H84V24H80V20Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 20H104V24H100V20Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 20H124V24H120V20Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 20H144V24H140V20Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 20H164V24H160V20Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 20H184V24H180V20Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 20H204V24H200V20Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 20H224V24H220V20Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 20H244V24H240V20Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 20H264V24H260V20Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 20H284V24H280V20Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 20H304V24H300V20Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 20H324V24H320V20Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 20H344V24H340V20Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 20H364V24H360V20Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 20H384V24H380V20Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 20H404V24H400V20Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 40H4V44H0V40Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 40H24V44H20V40Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 40H44V44H40V40Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 40H64V44H60V40Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 40H84V44H80V40Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 40H104V44H100V40Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 40H124V44H120V40Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 40H144V44H140V40Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 40H164V44H160V40Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 40H184V44H180V40Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 40H204V44H200V40Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 40H224V44H220V40Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 40H244V44H240V40Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 40H264V44H260V40Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 40H284V44H280V40Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 40H304V44H300V40Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 40H324V44H320V40Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 40H344V44H340V40Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 40H364V44H360V40Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 40H384V44H380V40Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 40H404V44H400V40Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 60H4V64H0V60Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 60H24V64H20V60Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 60H44V64H40V60Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 60H64V64H60V60Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 60H84V64H80V60Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 60H104V64H100V60Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 60H124V64H120V60Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 60H144V64H140V60Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 60H164V64H160V60Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 60H184V64H180V60Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 60H204V64H200V60Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 60H224V64H220V60Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 60H244V64H240V60Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 60H264V64H260V60Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 60H284V64H280V60Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 60H304V64H300V60Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 60H324V64H320V60Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 60H344V64H340V60Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 60H364V64H360V60Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 60H384V64H380V60Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 60H404V64H400V60Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 80H4V84H0V80Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 80H24V84H20V80Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 80H44V84H40V80Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 80H64V84H60V80Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 80H84V84H80V80Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 80H104V84H100V80Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 80H124V84H120V80Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 80H144V84H140V80Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 80H164V84H160V80Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 80H184V84H180V80Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 80H204V84H200V80Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 80H224V84H220V80Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 80H244V84H240V80Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 80H264V84H260V80Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 80H284V84H280V80Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 80H304V84H300V80Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 80H324V84H320V80Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 80H344V84H340V80Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 80H364V84H360V80Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 80H384V84H380V80Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 80H404V84H400V80Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 100H4V104H0V100Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 100H24V104H20V100Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 100H44V104H40V100Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 100H64V104H60V100Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 100H84V104H80V100Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 100H104V104H100V100Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 100H124V104H120V100Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 100H144V104H140V100Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 100H164V104H160V100Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 100H184V104H180V100Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 100H204V104H200V100Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 100H224V104H220V100Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 100H244V104H240V100Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 100H264V104H260V100Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 100H284V104H280V100Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 100H304V104H300V100Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 100H324V104H320V100Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 100H344V104H340V100Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 100H364V104H360V100Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 100H384V104H380V100Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 100H404V104H400V100Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 120H4V124H0V120Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 120H24V124H20V120Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 120H44V124H40V120Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 120H64V124H60V120Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 120H84V124H80V120Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 120H104V124H100V120Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 120H124V124H120V120Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 120H144V124H140V120Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 120H164V124H160V120Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 120H184V124H180V120Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 120H204V124H200V120Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 120H224V124H220V120Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 120H244V124H240V120Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 120H264V124H260V120Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 120H284V124H280V120Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 120H304V124H300V120Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 120H324V124H320V120Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 120H344V124H340V120Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 120H364V124H360V120Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 120H384V124H380V120Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 120H404V124H400V120Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 140H4V144H0V140Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 140H24V144H20V140Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 140H44V144H40V140Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 140H64V144H60V140Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 140H84V144H80V140Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 140H104V144H100V140Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 140H124V144H120V140Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 140H144V144H140V140Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 140H164V144H160V140Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 140H184V144H180V140Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 140H204V144H200V140Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 140H224V144H220V140Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 140H244V144H240V140Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 140H264V144H260V140Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 140H284V144H280V140Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 140H304V144H300V140Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 140H324V144H320V140Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 140H344V144H340V140Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 140H364V144H360V140Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 140H384V144H380V140Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 140H404V144H400V140Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 160H4V164H0V160Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 160H24V164H20V160Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 160H44V164H40V160Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 160H64V164H60V160Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 160H84V164H80V160Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 160H104V164H100V160Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 160H124V164H120V160Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 160H144V164H140V160Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 160H164V164H160V160Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 160H184V164H180V160Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 160H204V164H200V160Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 160H224V164H220V160Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 160H244V164H240V160Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 160H264V164H260V160Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 160H284V164H280V160Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 160H304V164H300V160Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 160H324V164H320V160Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 160H344V164H340V160Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 160H364V164H360V160Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 160H384V164H380V160Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 160H404V164H400V160Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 180H4V184H0V180Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 180H24V184H20V180Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 180H44V184H40V180Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 180H64V184H60V180Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 180H84V184H80V180Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 180H104V184H100V180Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 180H124V184H120V180Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 180H144V184H140V180Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 180H164V184H160V180Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 180H184V184H180V180Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 180H204V184H200V180Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 180H224V184H220V180Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 180H244V184H240V180Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 180H264V184H260V180Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 180H284V184H280V180Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 180H304V184H300V180Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 180H324V184H320V180Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 180H344V184H340V180Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 180H364V184H360V180Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 180H384V184H380V180Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 180H404V184H400V180Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 200H4V204H0V200Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 200H24V204H20V200Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 200H44V204H40V200Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 200H64V204H60V200Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 200H84V204H80V200Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 200H104V204H100V200Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 200H124V204H120V200Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 200H144V204H140V200Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 200H164V204H160V200Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 200H184V204H180V200Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 200H204V204H200V200Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 200H224V204H220V200Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 200H244V204H240V200Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 200H264V204H260V200Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 200H284V204H280V200Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 200H304V204H300V200Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 200H324V204H320V200Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 200H344V204H340V200Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 200H364V204H360V200Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 200H384V204H380V200Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 200H404V204H400V200Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 220H4V224H0V220Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 220H24V224H20V220Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 220H44V224H40V220Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 220H64V224H60V220Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 220H84V224H80V220Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 220H104V224H100V220Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 220H124V224H120V220Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 220H144V224H140V220Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 220H164V224H160V220Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 220H184V224H180V220Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 220H204V224H200V220Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 220H224V224H220V220Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 220H244V224H240V220Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 220H264V224H260V220Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 220H284V224H280V220Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 220H304V224H300V220Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 220H324V224H320V220Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 220H344V224H340V220Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 220H364V224H360V220Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 220H384V224H380V220Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 220H404V224H400V220Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 240H4V244H0V240Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 240H24V244H20V240Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 240H44V244H40V240Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 240H64V244H60V240Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 240H84V244H80V240Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 240H104V244H100V240Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 240H124V244H120V240Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 240H144V244H140V240Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 240H164V244H160V240Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 240H184V244H180V240Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 240H204V244H200V240Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 240H224V244H220V240Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 240H244V244H240V240Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 240H264V244H260V240Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 240H284V244H280V240Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 240H304V244H300V240Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 240H324V244H320V240Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 240H344V244H340V240Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 240H364V244H360V240Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 240H384V244H380V240Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 240H404V244H400V240Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 260H4V264H0V260Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 260H24V264H20V260Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 260H44V264H40V260Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 260H64V264H60V260Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 260H84V264H80V260Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 260H104V264H100V260Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 260H124V264H120V260Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 260H144V264H140V260Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 260H164V264H160V260Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 260H184V264H180V260Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 260H204V264H200V260Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 260H224V264H220V260Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 260H244V264H240V260Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 260H264V264H260V260Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 260H284V264H280V260Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 260H304V264H300V260Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 260H324V264H320V260Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 260H344V264H340V260Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 260H364V264H360V260Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 260H384V264H380V260Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 260H404V264H400V260Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 280H4V284H0V280Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 280H24V284H20V280Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 280H44V284H40V280Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 280H64V284H60V280Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 280H84V284H80V280Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 280H104V284H100V280Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 280H124V284H120V280Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 280H144V284H140V280Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 280H164V284H160V280Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 280H184V284H180V280Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 280H204V284H200V280Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 280H224V284H220V280Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 280H244V284H240V280Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 280H264V284H260V280Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 280H284V284H280V280Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 280H304V284H300V280Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 280H324V284H320V280Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 280H344V284H340V280Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 280H364V284H360V280Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 280H384V284H380V280Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 280H404V284H400V280Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 300H4V304H0V300Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 300H24V304H20V300Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 300H44V304H40V300Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 300H64V304H60V300Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 300H84V304H80V300Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 300H104V304H100V300Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 300H124V304H120V300Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 300H144V304H140V300Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 300H164V304H160V300Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 300H184V304H180V300Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 300H204V304H200V300Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 300H224V304H220V300Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 300H244V304H240V300Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 300H264V304H260V300Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 300H284V304H280V300Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 300H304V304H300V300Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 300H324V304H320V300Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 300H344V304H340V300Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 300H364V304H360V300Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 300H384V304H380V300Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 300H404V304H400V300Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 320H4V324H0V320Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 320H24V324H20V320Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 320H44V324H40V320Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 320H64V324H60V320Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 320H84V324H80V320Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 320H104V324H100V320Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 320H124V324H120V320Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 320H144V324H140V320Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 320H164V324H160V320Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 320H184V324H180V320Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 320H204V324H200V320Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 320H224V324H220V320Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 320H244V324H240V320Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 320H264V324H260V320Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 320H284V324H280V320Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 320H304V324H300V320Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 320H324V324H320V320Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 320H344V324H340V320Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 320H364V324H360V320Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 320H384V324H380V320Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 320H404V324H400V320Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 340H4V344H0V340Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 340H24V344H20V340Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 340H44V344H40V340Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 340H64V344H60V340Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 340H84V344H80V340Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 340H104V344H100V340Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 340H124V344H120V340Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 340H144V344H140V340Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 340H164V344H160V340Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 340H184V344H180V340Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 340H204V344H200V340Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 340H224V344H220V340Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 340H244V344H240V340Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 340H264V344H260V340Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 340H284V344H280V340Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 340H304V344H300V340Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 340H324V344H320V340Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 340H344V344H340V340Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 340H364V344H360V340Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 340H384V344H380V340Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 340H404V344H400V340Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 360H4V364H0V360Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 360H24V364H20V360Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 360H44V364H40V360Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 360H64V364H60V360Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 360H84V364H80V360Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 360H104V364H100V360Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 360H124V364H120V360Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 360H144V364H140V360Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 360H164V364H160V360Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 360H184V364H180V360Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 360H204V364H200V360Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 360H224V364H220V360Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 360H244V364H240V360Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 360H264V364H260V360Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 360H284V364H280V360Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 360H304V364H300V360Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 360H324V364H320V360Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 360H344V364H340V360Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 360H364V364H360V360Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 360H384V364H380V360Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 360H404V364H400V360Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 380H4V384H0V380Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 380H24V384H20V380Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 380H44V384H40V380Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 380H64V384H60V380Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 380H84V384H80V380Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 380H104V384H100V380Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 380H124V384H120V380Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 380H144V384H140V380Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 380H164V384H160V380Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 380H184V384H180V380Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 380H204V384H200V380Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 380H224V384H220V380Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 380H244V384H240V380Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 380H264V384H260V380Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 380H284V384H280V380Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 380H304V384H300V380Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 380H324V384H320V380Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 380H344V384H340V380Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 380H364V384H360V380Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 380H384V384H380V380Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 380H404V384H400V380Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 400H4V404H0V400Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 400H24V404H20V400Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 400H44V404H40V400Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 400H64V404H60V400Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 400H84V404H80V400Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 400H104V404H100V400Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 400H124V404H120V400Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 400H144V404H140V400Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 400H164V404H160V400Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 400H184V404H180V400Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 400H204V404H200V400Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 400H224V404H220V400Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 400H244V404H240V400Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 400H264V404H260V400Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 400H284V404H280V400Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 400H304V404H300V400Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 400H324V404H320V400Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 400H344V404H340V400Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 400H364V404H360V400Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 400H384V404H380V400Z",
    fill: "#50C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 400H404V404H400V400Z",
    fill: "#50C8FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_3915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 404,
    height: 404,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotPattern2);
export default __webpack_public_path__ + "static/media/dot-pattern-2.db88e5830802a63c159ac5a790fb0aa2.svg";
export { ForwardRef as ReactComponent };